import {DialogContent} from '@mui/material';
import PropTypes from 'prop-types';
import ActionsBar from './ActionsBar.jsx';
import DropZone from './DropZone.jsx';
import {MAX_LOCAL_FILE_SIZE_BYTES} from './util.js';

const UploadStep = ({onDropAccepted, onDropRejected, files, onClose}) => {
  return (
    <>
      <DialogContent dividers sx={{display: 'flex'}}>
        <DropZone
          onDropAccepted={onDropAccepted}
          onDropRejected={onDropRejected}
          files={files}
          maxBytes={MAX_LOCAL_FILE_SIZE_BYTES}
          sx={{
            overflow: 'hidden',
          }}
        />
      </DialogContent>

      <ActionsBar onClose={onClose} />
    </>
  );
};

UploadStep.propTypes = {
  onDropAccepted: PropTypes.func,
  onDropRejected: PropTypes.func,
  files: PropTypes.array,
  onClose: PropTypes.func,
};

export default UploadStep;
